const ACTIONS = {
    GET_PLAYLOG_SEARCH_SUCCESS: 'GET_PLAYLOG_SEARCH_SUCCESS',
    GET_PLAYLOG_SEARCH_ERROR: 'GET_PLAYLOG_SEARCH_ERROR',
    GET_GAMES_SUCCESS : 'GET_GAMES_SUCCESS',
    GET_GAMES_ERROR : 'GET_GAMES_ERROR'
};

const header = ['試合日付', '球場', 'ホーム', 'ビジター', 'イニング', 'イニング内打順', '投手', '打者', '結果'];

const listGame = [];
const dataPlaylogSearch = [];

for (let i = 0; i < 12; i += 1) {
    dataPlaylogSearch.push({
        item: [
            { text: '8/12' },
            { text: '甲子園' },
            { text: '阪神' },
            { text: '巨人' },
            { text: '1回表' },
            { text: '1' },
            { text: 'なまえ' },
            { text: 'なまえ' },
            { text: 'アウト' },
        ],
    });
}

export default (state = {
    header, dataPlaylogSearch, listGame
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_PLAYLOG_SEARCH_SUCCESS:
        case ACTIONS.GET_GAMES_SUCCESS:
                return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_PLAYLOG_SEARCH_ERROR:
        case ACTIONS.GET_GAMES_ERROR:
                return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};